
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "../../store/httpClient";
import { FertigerCalculationReportDto } from "../../dtos/fertigerCalculationReportDto";
import { PositionCalculationReportDto } from "../../dtos/positionCalculationReportDto";
import { ManufacturerSettlementReportType } from "../../dtos/manufacturerSettlementReportType";
import moment from "moment";
import FileSaver from "file-saver";
import store from "../../store/store";
import PriceModelDefault from "@/dtos/priceModel";
import DatePicker from "@/components/DatePicker.vue";

@Component({
	components: {
		"date-picker": DatePicker,
	},
})
export default class ManufacturerSettlementDashboard extends Vue {
	private isLoadingExcel: boolean = false;
	private idToAdd: string = "";
	private showRecalculateDialog: boolean = false;
	private recalculationIds: string[] = [];
	private showResults: boolean = false;
	private suchbegriff: string = "";
	private lieferterminImZeitraum: boolean = false;
	private eingegangenImZeitraum: boolean = false;
	private startDate: string = moment().subtract(5, "days").format("YYYY-MM-01 00:00:00");
	private endDate: string = moment(moment().subtract(5, "days").format("YYYY-MM-01 00:00:00"))
		.add(1, "month")
		.subtract(1, "days")
		.format("YYYY-MM-DD 23:59:59");
	private loading: boolean = false;
	private showCalculationDetailsDialog: boolean = false;
	private currentPosition: any = {};
	private fertigerCalculationReport: FertigerCalculationReportDto | null = null;
	private getPriceModelText = PriceModelDefault.getPriceModelText;
	private fertiger: any = null;
	private reportType: any = 0;
	private headers: Array<{
		text: string;
		value: string;
		align: string;
		sortable: boolean;
		width: string;
	}> = Array(
		{
			text: "KndNr",
			value: "customerId",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Order Id",
			value: "companyName",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Eingegangen am",
			value: "surname",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Lieferdatum",
			value: "",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Fertigerpreis",
			value: "name",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Kunden-Auftragspreis (inkl. Rabatt)",
			value: "eMail",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Deckungsbeitrag",
			value: "registriertAm",
			align: "left",
			sortable: false,
			width: "10px",
		},
		{
			text: "Laserbearbeitung",
			value: "registriertAm",
			align: "left",
			sortable: false,
			width: "10px",
		},
		{
			text: "Abkanten",
			value: "registriertAm",
			align: "left",
			sortable: true,
			width: "10px",
		}
	);

	private detailHeaders: Array<{
		text: string;
		value: string;
		align: string;
		sortable: boolean;
		width: string;
	}> = Array(
		{
			text: "Arbeitsschritt",
			value: "customerId",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Dauer [hh:mm:ss]",
			value: "companyName",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Kundenpreis (für Menge)",
			value: "surname",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Blexonanteil (für Menge)",
			value: "surname",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Fertigerpreis (für Menge)",
			value: "name",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Materialpreis",
			value: "name",
			align: "left",
			sortable: false,
			width: "1px",
		}
	);

	private positionHeader: Array<{
		text: string;
		value: string;
		align: string;
		sortable: boolean;
		width: string;
	}> = Array(
		{
			text: "Artikel",
			value: "customerId",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Artikel Id",
			value: "companyName",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Material",
			value: "surname",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Menge",
			value: "name",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Fertigerpreis",
			value: "eMail",
			align: "left",
			sortable: false,
			width: "10px",
		},
		{
			text: "Externe Kosten",
			value: "",
			align: "left",
			sortable: false,
			width: "10px",
		},
		{
			text: "Kundenpreis",
			value: "registriertAm",
			align: "left",
			sortable: false,
			width: "10px",
		},
		{
			text: "Laserbearbeitung",
			value: "registriertAm",
			align: "left",
			sortable: false,
			width: "10px",
		},
		{
			text: "Abkanten",
			value: "registriertAm",
			align: "left",
			sortable: false,
			width: "10px",
		}
	);

	private get fertigers() {
		const fertiger = store.state.fertigers.slice();
		fertiger.unshift({
			name: "Alle Fertiger",
			id: 0,
		});
		return fertiger;
	}
	private get filteredOrders() {
		if (this.fertigerCalculationReport === null) {
			return [];
		}
		let filteredItems = this.fertigerCalculationReport.orderCalculationReportDtos;
		if (this.suchbegriff !== "" && this.suchbegriff !== null) {
			filteredItems = filteredItems.filter(
				(o) =>
					o.orderId.includes(this.suchbegriff) || o.customerId.includes(this.suchbegriff)
			);
		}
		if (this.lieferterminImZeitraum) {
			filteredItems = filteredItems.filter(
				(o) =>
					moment(o.deliveryDate).isSameOrAfter(this.startDate) &&
					moment(o.deliveryDate).isSameOrBefore(
						moment(this.endDate).format("YYYY-MM-DD 23:59:59")
					)
			);
		}
		if (this.eingegangenImZeitraum) {
			filteredItems = filteredItems.filter(
				(o) =>
					moment(o.receivedAt).isSameOrAfter(this.startDate) &&
					moment(o.receivedAt).isSameOrBefore(
						moment(this.endDate).format("YYYY-MM-DD 23:59:59")
					)
			);
		}
		return filteredItems;
	}

	private get deckungsbeitrag() {
		var transportCost = 0;
		if (this.effektiveTransportkosten.length > 0) {
			transportCost = this.effektiveTransportkosten.reduce((a, k) => ({
				cost: a.cost + k.cost,
				name: "",
			})).cost;
		}
		// Blexon discount ist negativ, wenn blexon was bezahlen muss
		return (
			this.summeCustomerOrderPrices -
			transportCost -
			this.summeFertiger +
			this.summeBlexonDiscounts
		);
	}

	private get deckungsbeitragInProzent() {
		return (this.deckungsbeitrag / this.summeCustomerOrderPrices) * 100;
	}

	private get summeFertiger() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.totalFertigerPrice;
		}
		const discount = this.totalDiscounts;
		summe += discount;
		return summe;
	}

	private get totalDiscounts() {
		return (
			this.summeManufacturerDiscounts +
			this.summePowderCoaterDiscounts +
			this.summeHotDipZincCoaterDiscounts +
			this.summeGalvanizeZincCoaterDiscounts
		);
	}

	private get summeCustomerOrderPrices() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.totalCustomerOrderPrice;
		}
		const discount = this.totalDiscounts;
		summe += discount;
		return summe;
	}

	private get summePulverbeschichtungsAufwand() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.pulverbeschichtungsAufwand;
		}
		return summe;
	}

	private get summeFeuerverzinkenAufwand() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.feuerverzinkenAufwand;
		}
		return summe;
	}

	private get summeGalvanischVerzinkenAufwand() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.galvanischVerzinkenAufwand;
		}
		return summe;
	}

	private get summeZertifikatsaufwand() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.zertifikatsaufwand;
		}
		return summe;
	}

	private get summeVerpackungsmaterial() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.verpackungsmaterial;
		}
		return summe;
	}

	private get summeMaterialaufwand() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.materialaufwand;
		}
		return summe;
	}

	private get summeManufacturingComplaint() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.totalManufacturingComplaints;
		}
		return summe;
	}

	private get summePowderCoatingComplaint() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.totalPowderCoatingComplaints;
		}
		return summe;
	}

	private get summeHotDipZincCoatingComplaint() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.totalHotDipZincCoatingComplaints;
		}
		return summe;
	}

	private get summeGlavanizeZincCoatingComplaint() {
		let summe = 0;
		for (const order of this.filteredOrders) {
			summe += order.totalGalvanizeZincCoatingComplaints;
		}
		return summe;
	}

	private get summeManufacturerDiscounts() {
		if (this.fertigerCalculationReport == null) return 0;
		var summe = 0;
		this.fertigerCalculationReport.discounts.forEach((d) => (summe += d.manufacturerShare));
		return summe;
	}

	private get summePowderCoaterDiscounts() {
		if (this.fertigerCalculationReport == null) return 0;
		var summe = 0;
		this.fertigerCalculationReport.discounts.forEach((d) => (summe += d.powderCoaterShare));
		return summe;
	}

	private get summeHotDipZincCoaterDiscounts() {
		if (this.fertigerCalculationReport == null) return 0;
		var summe = 0;
		this.fertigerCalculationReport.discounts.forEach((d) => (summe += d.hotDipCoaterShare));
		return summe;
	}

	private get summeGalvanizeZincCoaterDiscounts() {
		if (this.fertigerCalculationReport == null) return 0;
		var summe = 0;
		this.fertigerCalculationReport.discounts.forEach((d) => (summe += d.galvanizeCoaterShare));
		return summe;
	}

	private get summeBlexonDiscounts() {
		if (this.fertigerCalculationReport == null) return 0;
		var summe = 0;
		this.fertigerCalculationReport.discounts.forEach((d) => (summe += d.blexonShare));
		return summe;
	}

	private get effektiveTransportkosten() {
		const kosten: Array<{ cost: number; name: string }> = Array();
		for (const order of this.filteredOrders) {
			if (order.transportCompany !== "") {
				let group = kosten.find((k) => k.name === order.transportCompany);
				if (group === undefined) {
					group = {
						cost: order.transportAufwand,
						name: order.transportCompany,
					};
					kosten.push(group);
				} else {
					group.cost += order.transportAufwand;
				}
			}
		}
		return kosten;
	}

	private priceIsWrong(orderCalculationReportDto: any) {
		if (
			orderCalculationReportDto.positionCalculationReportDtos.filter(
				(p: PositionCalculationReportDto) =>
					p.fertigerPrice === 0 &&
					p.thirdPartyCost === 0 &&
					p.customerOrderPrice > 0 &&
					p.materialName &&
					!p.description.includes("Kurier") &&
					!p.description.includes("(gemäss Beanstandung)")
			).length > 0
		) {
			console.log(
				orderCalculationReportDto.positionCalculationReportDtos.filter(
					(p: PositionCalculationReportDto) =>
						p.fertigerPrice === 0 &&
						p.thirdPartyCost === 0 &&
						p.customerOrderPrice > 0 &&
						p.materialName &&
						!p.description.includes("Kurier") &&
						!p.description.includes("(gemäss Beanstandung)")
				)
			);
			return true;
		}
		return false;
	}

	private get canExport() {
		if (this.fertigerCalculationReport === null) {
			return false;
		}
		for (const orderReport of this.filteredOrders) {
			if (this.priceIsWrong(orderReport)) {
				return false;
			}
		}
		return true;
	}

	private showCalculationDetails(position: any, order: any) {
		this.currentPosition = position;
		this.showCalculationDetailsDialog = true;
	}

	private async loadFertigerPrices() {
		if (this.fertiger !== null) {
			try {
				this.resetResults();
				this.loading = true;
				const response = await httpClient().get(
					`Calculation/GetFertigerPrices?von=${this.startDate}&bis=${this.endDate}` +
						`&fertigerId=${this.fertiger.id}`
				);
				this.fertigerCalculationReport = response.data;
				this.showResults = true;
			} catch {
				console.log("Load calculations failed.");
			} finally {
				this.loading = false;
			}
		}
	}

	@Watch("fertiger")
	private resetResults() {
		this.showResults = false;
		this.fertigerCalculationReport = null;
	}

	@Watch("showRecalculateDialog")
	private fillRecalculationIds() {
		this.recalculationIds.length = 0;
		for (const order of this.filteredOrders) {
			this.recalculationIds.push(order.orderId);
		}
	}

	private setStartDate(date: Date) {
		this.startDate = moment(date).format("YYYY-MM-DD");
		this.resetResults();
	}
	private setEndDate(date: Date) {
		this.endDate = moment(date).format("YYYY-MM-DD");
		this.resetResults();
	}

	private async getExcel(type: ManufacturerSettlementReportType) {
		if (this.fertiger.name !== undefined) {
			try {
				const reports: number[] = [];
				if ((type as any) === -1) {
					reports.push(0, 1, 2, 3);
				} else {
					reports.push(type);
				}
				this.isLoadingExcel = true;
				for (const report of reports) {
					const response = await httpClient().get(
						`Calculation/GetExcel?von=${this.startDate}&bis=${this.endDate}` +
							`&fertigerId=${this.fertiger.id}` +
							`&lieferterminImZeitraum=${this.lieferterminImZeitraum}` +
							`&eingegangenImZeitraum=${this.eingegangenImZeitraum}` +
							`&reportType=${report}`,
						{
							method: "GET",
							responseType: "blob",
						}
					);
					const start = moment(this.startDate).format("DD.MM.YYYY");
					const ende = moment(this.endDate).format("DD.MM.YYYY");
					let filter = "";
					if (this.lieferterminImZeitraum) {
						filter = "nach Auslieferung";
					}
					if (this.eingegangenImZeitraum) {
						filter += "nach Auftragseingang";
					}
					var filenamepart = "";
					switch (report) {
						case 0:
							filenamepart = "Fertigung";
							break;
						case 1:
							filenamepart = "Pulverbeschichtung";
							break;
						case 2:
							filenamepart = "Feuerverzinken";
							break;
						case 3:
							filenamepart = "galvanisch Verzinken";
							break;
					}
					const filename =
						this.fertiger.name + ` ${filenamepart} ${filter} ${start} - ${ende}.xlsx`;
					FileSaver.saveAs(new Blob([response.data]), filename);
				}
			} catch {
				console.log("Get excel failed.");
			} finally {
				this.isLoadingExcel = false;
			}
		}
	}

	/**
	 * Berechnet die Auftragspreise und Zeiten der gewählten orders neu.
	 */
	private async neuBerechnen() {
		try {
			this.loading = true;
			this.showResults = false;
			for (const id of this.recalculationIds) {
				await httpClient().post(`Calculation/Recalculate?orderId=${id}`, null);
			}
		} catch {
			console.log("Recalculation failed.");
		} finally {
			this.showRecalculateDialog = false;
			this.loadFertigerPrices();
		}
	}
}
